import { render } from "./Employes.vue?vue&type=template&id=bc732d78"
import script from "./Employes.vue?vue&type=script&lang=js"
export * from "./Employes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__